import React from 'react'
import './Table.css'

function Table(props) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-hover table-bordered">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        {props.columns.map((col, index) => <th key={index} scope="col">{col}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {props.rows.map((row, index) =>
                        <tr key={index} onClick={() => props.onRowSelected(row)}>
                            <th scope="row">{index + 1}</th>
                            {
                                Object.entries(row).map(([key, value], index) => {
                                    if (props.ignoreProps == null || props.ignoreProps.includes(key) == false) {
                                        return <td key={index}>{value}</td>
                                    }
                                })
                            }
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}


export default Table
